module.exports = __webpack_public_path__ + "img/ew-icon_hidden.f6a72fe9.svg";